module.exports = __webpack_public_path__ + "img/systemmanagement.40d5187c.png";